var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"main-visual-info-wrap"},[_c('div',{staticClass:"main-visual-info"},[_c('img',{class:{ 'mobile-logo': _vm.isMobile },attrs:{"src":_vm.logoImage,"alt":"5월 동행축제에 참여해주셔서 진심으로 감사드립니다. 9월 동행축제에도 많은 관심과 참여 부탁드리겠습니다. 동행축제 2024 5.1 ~ 5.30 K SHOPPING FESTA 중소벤처기업부, 한국중소벤처기업유통원, 소상공인시장진흥공단"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }